import React from 'react';
import { useTranslation } from 'react-i18next';
import './StudentDashboard.css';
import { Card, CardContent, Typography, Box } from '@mui/material';
import ClassIcon from '@mui/icons-material/Class';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useNavigate } from 'react-router-dom';

interface StudentDashboardProps {
  student: any;
}

const StudentDashboard: React.FC<StudentDashboardProps> = ({ student }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const infoParts: string[] = [];
  if (student.grade_level) infoParts.push(t('studentDashboard.gradeLevel', { grade: student.grade_level }));
  if (student.reading_level) infoParts.push(t('studentDashboard.readingLevel', { level: student.reading_level }));

  return (
    <div className="student-dashboard">
      <div className="student-dashboard-header">
        <h1>{t('studentDashboard.welcome', { name: student.first_name })}</h1>
        <p className="student-info">
          {infoParts.join(' • ')}
        </p>
      </div>

      <div className="student-dashboard-grid">
        <Card 
          className="dashboard-card clickable" 
          onClick={() => navigate('/student/classes')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              navigate('/student/classes');
            }
          }}
          aria-label={t('studentDashboard.actions.openMyClassesAria')}
        >
          <CardContent>
            <Box className="card-icon-header">
              <ClassIcon sx={{ fontSize: 48, color: '#1976d2' }} />
            </Box>
            <Typography variant="h5" component="h2" gutterBottom>
              {t('studentDashboard.myClasses')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('studentDashboard.classCount', { count: student.class_count || 0 })}
            </Typography>
          </CardContent>
        </Card>

        <Card 
          className="dashboard-card clickable" 
          onClick={() => navigate('/student/assignments')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              navigate('/student/assignments');
            }
          }}
          aria-label={t('studentDashboard.actions.openMyAssignmentsAria')}
        >
          <CardContent>
            <Box className="card-icon-header">
              <AssignmentIcon sx={{ fontSize: 48, color: '#f57c00' }} />
            </Box>
            <Typography variant="h5" component="h2" gutterBottom>
              {t('studentDashboard.myAssignments')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('studentDashboard.assignmentCount', { count: student.assignment_count || 0 })}
            </Typography>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StudentDashboard;

